export const notInSpecificPage = (location: string, pageName: string) => {
    return location.includes(`/${pageName}`);
};
